import { prepareData, service } from "./services";
import { getTheExactQuarter } from "./helpers";

let timestamps = [];
let callsHistory = [];
const reset = function () {
  timestamps = [];
  callsHistory = [];
};

const checkEventInHistory = (keyEvent) => {
  return callsHistory.includes(keyEvent);
};
export const onCreate = async (audio, infos) => {
  window.parent.postMessage(
    {
      info: "sendDataToParent",
      value: { event: "create", currentTime: audio.getCurrentTime() },
    },
    "*"
  );
  const data = prepareData("create", audio, infos);
  await service(data);
};
export const onFirstPlay = (audio, infos) => {
  audio.on("play", async () => {
    window.parent.postMessage(
      {
        info: "sendDataToParent",
        value: { event: "play", currentTime: audio.getCurrentTime() },
      },
      "*"
    );
    if (audio.getCurrentTime() === 0 && !checkEventInHistory("firstplay0")) {
      const data = prepareData("firstplay", audio, infos);
      await service(data);
      callsHistory.push("firstplay0");
    }
  });
};
export const onPlay = (audio, infos) => {
  audio.on("play", async () => {
    window.parent.postMessage(
      {
        info: "sendDataToParent",
        value: { event: "play", currentTime: audio.getCurrentTime() },
      },
      "*"
    );
    const strObj = "play" + Math.trunc(audio.getCurrentTime());
    if (!checkEventInHistory(strObj)) {
      const data = prepareData("play", audio, infos);
      await service(data);
      callsHistory.push(strObj);
    }
  });
};

export const onSeek = (audio, infos) => {
  audio.on("seek", async () => {
    infos.HasSeeked = true;
    if (infos.seekCount !== undefined) {
      infos.seekCount += 1;
    }
    window.parent.postMessage(
      {
        info: "sendDataToParent",
        value: { event: "seek", currentTime: audio.getCurrentTime() },
      },
      "*"
    );
    const eObj = "seek" + Math.trunc(audio.currentTime);
    if (!checkEventInHistory(eObj)) {
      const data = prepareData("seek", audio, infos);
      await service(data);
      callsHistory.push(eObj);
    }
  });
};
export const onTimeUpdate = (audio, infos) => {
  audio.on("audioprocess", async () => {
    const curTime = Math.trunc(audio.getCurrentTime());
    const oldTime = infos?.currentT;
    infos.currentT = Math.trunc(audio.getCurrentTime());

    if (timestamps.indexOf(curTime) < 0) {
      timestamps.push(curTime);
    }
    if (Math.trunc(audio?.getCurrentTime()) > oldTime) {
      infos.watchedDuration = timestamps.length - 1;
      const Quarter = getTheExactQuarter(audio.getDuration(), audio.getCurrentTime());
      let eventName = "play";
      switch (Quarter) {
        case 0:
          eventName = "play";
          break;
        case 1:
          eventName = "first-quarter";
          break;
        case 2:
          eventName = "second-quarter";
          break;
        case 3:
          eventName = "third-quarter";
          break;
        case 4:
          eventName = "fourth-quarter";
          break;
      }

      const data = prepareData("timeupdate", audio, infos);
      
      if (eventName !== "play") {
        data["x-event"] = eventName;
        const eObj = eventName + Math.trunc(audio.getCurrentTime());
        if (!checkEventInHistory(eObj)) {
          callsHistory.push(eObj);
          await service(data);
        }
      }
      data["x-event"] = "play";
      const sObj = "play" + Math.trunc(audio.getCurrentTime());

      if (!checkEventInHistory(sObj)) {
        callsHistory.push(sObj);

        await service(data);
      }
    }
  });
};

export const onPause = (audio, infos) => {
  audio.on("pause", async () => {
    if (infos.pauseCount !== undefined) {
      infos.pauseCount += 1;
    }
    window.parent.postMessage(
      {
        info: "sendDataToParent",
        value: { event: "pause", currentTime: audio.getCurrentTime() },
      },
      "*"
    );
    const sObj = "pause" + Math.trunc(audio.getCurrentTime());
    if (!checkEventInHistory(sObj)) {
      callsHistory.push(sObj);
      const data = prepareData("pause", audio, infos);
      await service(data);
    }
  });
};

export const onLoad = (audio, infos) => {
  audio.on("ready", async () => {
    window.parent.postMessage(
      {
        info: "sendDataToParent",
        value: { event: "load", currentTime: audio.getCurrentTime() },
      },
      "*"
    );
    const data = prepareData("load", audio, infos);
    await service(data);
  });
};

export const Ended = (audio, infos) => {
  audio.on("finish", async () => {
    window.parent.postMessage(
      {
        info: "sendDataToParent",
        value: { event: "ended", currentTime: audio.getCurrentTime() },
      },
      "*"
    );
    const data = prepareData("performance", audio, infos);
    await service(data);
    reset();
  });
};
